package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import core.dateformat.utils.formatTimestampToHHMM
import core.dateformat.utils.timeDiff
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceValidation
import com.essntl.uikit.components.iconbutton.secondary.EsMediumSecondaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.date.EsDateInput
import com.essntl.uikit.components.input.time.EsTimeInput
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esTypography
import core.validation.EsInputState

@Composable
fun DateTimeComponent(
    itineraryService: ItineraryServiceModel,
    validation: EditItineraryServiceValidation,
    onItineraryServiceChange: (ItineraryServiceModel) -> Unit,
    modifier: Modifier = Modifier,
) {
    LaunchedEffect(
        itineraryService.startDate,
        itineraryService.endDate,
        itineraryService.startTime,
        itineraryService.endTime,
    ) {
        val time = timeDiff(
            formatTimestampToHHMM(itineraryService.startTime.orEmpty()),
            formatTimestampToHHMM(itineraryService.endTime.orEmpty()),
        )

        if (time != null &&
            (itineraryService.startDate == itineraryService.endDate && time <= 0)
        ) {
            validation.editItineraryServiceForm.timeRange.secondState = EsInputState.Error
            validation.editItineraryServiceForm.timeRange.secondErrorMessage =
                "The second time must be greater than the first time."
        }
    }

    Column(
        modifier = modifier,
    ) {
        // Start Date & Time
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            EsMediumSecondaryIconButton(
                iconRes = EsIcons.Date,
                onClick = {},
            )
            Spacer(modifier = Modifier.width(width = 1.5.spacing))

            Text(
                text = "Start Date & Time",
                style = MaterialTheme.esTypography.p2Medium14,
            )
        }
        Spacer(modifier = Modifier.height(height = 1.5.spacing))
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            EsDateInput(
                value = itineraryService.startDate,
                onValueChange = {
                    validation.editItineraryServiceForm.dateRange.validate(it, itineraryService.endDate.orEmpty())
                    validation.editItineraryServiceForm.timeRange.validate(
                        formatTimestampToHHMM(itineraryService.startTime.orEmpty()),
                        formatTimestampToHHMM(itineraryService.endTime.orEmpty()),
                    )

                    //validation.editItineraryServiceForm.startDate.validate(it)

                    onItineraryServiceChange(
                        itineraryService.copy(
                            startDate = (it),
                        ),
                    )
                },
                state = validation.editItineraryServiceForm.dateRange.firstState,
                message = validation.editItineraryServiceForm.dateRange.firstErrorMessage,
                enabled = true,
                modifier = Modifier.weight(1f),
            )

            Spacer(modifier = Modifier.width(width = 1.5.spacing))

            EsTimeInput(
                value = formatTimestampToHHMM(itineraryService.startTime.orEmpty()),
                onValueChange = {
                    // validation.editItineraryServiceForm.startTime.validate(it)
                    validation.editItineraryServiceForm.timeRange.validate(
                        it,
                        formatTimestampToHHMM(itineraryService.endTime.orEmpty()),
                    )
                    onItineraryServiceChange(
                        itineraryService.copy(
                            startTime = it,
                        ),
                    )
                },
                state = validation.editItineraryServiceForm.timeRange.firstState,
                message = validation.editItineraryServiceForm.timeRange.firstErrorMessage,
                enabled = true,
                maxLines = 1,
                modifier =
                    Modifier
                        .weight(1f),
            )
        }

        Spacer(modifier = Modifier.height(height = 3.spacing))

        // End Date & Time
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            EsMediumSecondaryIconButton(
                iconRes = EsIcons.Date,
                onClick = {},
            )
            Spacer(modifier = Modifier.width(width = 1.5.spacing))

            Text(
                text = "End Date & Time",
                style = MaterialTheme.esTypography.p2Medium14,
            )
        }
        Spacer(modifier = Modifier.height(height = 1.5.spacing))
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            EsDateInput(
                value = itineraryService.endDate.orEmpty(),
                onValueChange = {

                    //validation.editItineraryServiceForm.endDate.validate(it)

                    validation.editItineraryServiceForm.dateRange.validate(itineraryService.startDate, it)
                    validation.editItineraryServiceForm.timeRange.validate(
                        formatTimestampToHHMM(itineraryService.startTime.orEmpty()),
                        formatTimestampToHHMM(itineraryService.endTime.orEmpty()),
                    )

                    onItineraryServiceChange(
                        itineraryService.copy(
                            endDate = (it),
                        ),
                    )
                },
                state = validation.editItineraryServiceForm.dateRange.secondState,
                message = validation.editItineraryServiceForm.dateRange.secondErrorMessage,
                enabled = true,
                modifier =
                    Modifier
                        .weight(1f),
            )

            Spacer(modifier = Modifier.width(width = 1.5.spacing))

            EsTimeInput(
                value = formatTimestampToHHMM(itineraryService.endTime.orEmpty()),
                onValueChange = {
//                    validation.editItineraryServiceForm.endTime.validate(it)
                    validation.editItineraryServiceForm.timeRange.validate(
                        formatTimestampToHHMM(itineraryService.startTime.orEmpty()),
                        it,
                    )
                    onItineraryServiceChange(
                        itineraryService.copy(
                            endTime = it,
                        ),
                    )
                },
                state = validation.editItineraryServiceForm.timeRange.secondState,
                message = validation.editItineraryServiceForm.timeRange.secondErrorMessage,
                enabled = true,
                maxLines = 1,
                modifier =
                    Modifier
                        .weight(1f),
            )
        }

    }
}